export default __webpack_public_path__ + "static/Storage_Box-6390ba4bdbbef65980f9512c8f364e53.png";